import axios from "axios";
import { validateClinicBranchParams } from "@/utils/routeValidation";

const moduleDfCorrection = {
  namespaced: true,
  state: {},
  mutations: {},
  actions: {
    fetchReceiptItems({ commit }, payload) {
      if (
        !validateClinicBranchParams(
          payload.clinicUrl,
          payload.branchUrl,
          "fetchReceiptItems"
        )
      ) {
        const error = new Error(
          "Invalid clinic/branch parameters for fetchReceiptItems"
        );
        error.code = "INVALID_PARAMS";
        return Promise.reject(error);
      }
      return axios
        .get(
          `/api/report/receiptItem/${payload.clinicUrl}/${payload.branchUrl}`,
          {
            params: {
              startDt: payload.startDt,
              endDt: payload.endDt,
              actionUid: payload.actionUid || undefined,
            },
          }
        )
        .then(res => res)
        .catch(err => {
          throw err;
        });
    },

    createDfCorrection({ commit }, payload) {
      if (
        !validateClinicBranchParams(
          payload.clinicUrl,
          payload.branchUrl,
          "createDfCorrection"
        )
      ) {
        const error = new Error(
          "Invalid clinic/branch parameters for createDfCorrection"
        );
        error.code = "INVALID_PARAMS";
        return Promise.reject(error);
      }
      const body = {
        correctedDf: payload.correctedDf,
        correctedDfType: payload.correctedDfType,
        remark: payload.remark,
      };
      if (payload.correctedActionUid !== undefined) {
        body.correctedActionUid = payload.correctedActionUid;
      }
      return axios
        .post(
          `/api/receipt/${payload.clinicUrl}/${payload.branchUrl}/${payload.receiptId}/items/${payload.receiptItemId}/df-correction`,
          body
        )
        .then(res => res)
        .catch(err => {
          throw err;
        });
    },

    fetchDfCorrectionHistory({ commit }, payload) {
      if (
        !validateClinicBranchParams(
          payload.clinicUrl,
          payload.branchUrl,
          "fetchDfCorrectionHistory"
        )
      ) {
        const error = new Error(
          "Invalid clinic/branch parameters for fetchDfCorrectionHistory"
        );
        error.code = "INVALID_PARAMS";
        return Promise.reject(error);
      }
      return axios
        .get(
          `/api/receipt/${payload.clinicUrl}/${payload.branchUrl}/${payload.receiptId}/items/${payload.receiptItemId}/df-corrections`
        )
        .then(res => res)
        .catch(err => {
          throw err;
        });
    },
  },
  getters: {},
};

export default moduleDfCorrection;
